
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Task } from "@/types/task";
import { TaskStatusBadge, TaskPriorityBadge } from "./TaskBadges";
import { Card } from "@/components/ui/card";
import { TaskCountdown } from "./TaskCountdown";

interface TasksTableProps {
  tasks: Task[];
  onTaskClick: (task: Task) => void;
}

export function TasksTable({ tasks, onTaskClick }: TasksTableProps) {
  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>العنوان</TableHead>
            <TableHead>الحالة</TableHead>
            <TableHead>الأولوية</TableHead>
            <TableHead>الوقت المتبقي</TableHead>
            <TableHead>مُسندة إلى</TableHead>
            <TableHead>الإجراءات</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {tasks.map((task) => {
            const isOverdue = task.due_date && new Date(task.due_date) < new Date() && task.status !== 'completed' && task.status !== 'cancelled';
            return (
              <TableRow 
                key={task.id} 
                className={isOverdue ? 'bg-red-50 hover:bg-red-100' : ''}
                onClick={() => onTaskClick(task)}
                style={{ cursor: 'pointer' }}
              >
                <TableCell className="font-medium">{task.title}</TableCell>
                <TableCell>
                  <TaskStatusBadge status={task.status} />
                </TableCell>
                <TableCell>
                  <TaskPriorityBadge priority={task.priority} />
                </TableCell>
                <TableCell>
                  {task.status !== 'completed' && task.status !== 'cancelled' ? (
                    <TaskCountdown dueDate={task.due_date} />
                  ) : task.due_date ? (
                    new Date(task.due_date).toLocaleDateString("ar-SA")
                  ) : (
                    "غير محدد"
                  )}
                </TableCell>
                <TableCell>{task.assigned_employee?.name || "غير محدد"}</TableCell>
                <TableCell>
                  <Button variant="outline" size="sm" onClick={(e) => { e.stopPropagation(); onTaskClick(task); }}>
                    تفاصيل
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Card>
  );
}
